import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpRequestParam, Note, PageResponse} from "../../../core/models/entities";
import {isDefined} from "../../../features/utils/functions.utils";


@Injectable({
  providedIn: 'root'
})
export class ProtocolNoteService {
  url = `${environment.apiUrl}/protocol/note`;

  constructor(private http: HttpClient) { }

//rivedere dto standard per filtri e paginazione e sort
  getItems( protocolId: number, page?:number, pageItems?:number) {
    const params:  HttpRequestParam = {"f.protocolId": protocolId}
    // if( isDefined( obsolete ) ) {
    //   params['f.obsolete_is'] = obsolete;
    // }
    if(isDefined(page)) params["page"] = page;
    if(isDefined(pageItems)) params["pageItems"] = pageItems;
    return this.http.get<PageResponse<Note>>(`${this.url}`,  {params: params });
  }

  create(protocolId: number, note: string) {
    return this.http.post(`${this.url}/${protocolId}`, note);

  }

  restore(protocolId: number, itemId: number) {
    return this.http.patch(`${this.url}/${protocolId}/${itemId}/restore`, null );

  }

  edit(protocolId: number, note: string, itemId: any) {
    return this.http.patch(`${this.url}/${protocolId}/${itemId}`, note );

  }
  delete(protocolId: number, itemId: any) {
    return this.http.delete(`${this.url}/${protocolId}/${itemId}`, );

  }
}
